<template>
    <v-app>
          <v-tabs
                    v-model="tab"
                    
                    color="green"
                    class="mt-lg-2"
                   
                    >
                    <v-tab
                        v-for="item in items"
                        :key="item"
                         class="rounded-lg"
                         @click="itemClick(item)"
                    >
                    <span class="tab-color"> {{ item }} </span>
                    </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab" >
                    <v-tab-item
                        v-for="item in items"
                        :key="item"
                    >
                        <v-card
                      
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'WEEKLY'"
                        >
                        
                        
                            <weekly class="mt-lg-n5" :mo-num="moNum" :wk-report="wkReport"  ref="weeklyReport" v-on:weekForm="getInfoFromAssessment($event)"/>
                      


                        </v-card>
                        <v-card

                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'MONTHLY'"
                        >
                        
                          <monthly class="mt-lg-n5" :mo-num="moNum" :mo-report="moReport" :tutor-name="tutorName"  ref="weeklyReport" v-on:monthForm="getMonthAssessment($event)"/>


                        </v-card>


                        

                    </v-tab-item>
                    </v-tabs-items>
      
       

    </v-app>
</template>
<style scoped>

</style>
<script>

import weekly from '@/components/MonitoringRating/Performance/classHandling/weeklyReport'
import monthly from '@/components/MonitoringRating/Performance/classHandling/monthlyReport'
import Vue from 'vue'
export default {
    name: "Summary",
    props:['bus',"moNum","tutorName","monthUpdate"],
     components:{
     weekly,
     monthly
    },
    data: () => ({
      tab:null,
      items: [
            'WEEKLY','MONTHLY'
            ],
    status:'',
    wkReport: new Vue(),
    moReport:  new Vue(),

     
    }),
    mounted() {
        
    this.bus.$on('sendUpdateWeek', this.sendUpdateWeek)
    this.bus.$on('sendUpdateMonth', this.sendUpdateMonth)
    },  
    methods:{
         getInfoFromAssessment(id){

           this.$emit('getInfoFromAssessment',id)

        },
        getMonthAssessment(id){
            this.$emit('getMonthAssessment',id)
        },
        sendUpdateWeek(){

            this.wkReport.$emit('updateWeeks')
           
        },
        sendUpdateMonth(){
             this.moReport.$emit('updateMonths')
        },
        itemClick(item){
            this.$emit('itemClick',item)
        }
    }
}
</script>